import * as types from '../types.js';

export default {
	html: `
		<style>
			#product-packaging .pkg-hint { font-size: 0.78rem; color: #6b7280; margin: 0.15rem 0 0 0; line-height: 1.35; max-width: 42rem; }
			#product-packaging .pkg-check-row { display: flex; flex-wrap: wrap; align-items: center; gap: 1rem 1.25rem; margin-top: 0.35rem; }
			#product-packaging .pkg-check-row label { display: inline-flex; align-items: center; gap: 0.45rem; margin: 0; }
			#product-packaging .pkg-check-row input[type="checkbox"] { width: 1.05rem; height: 1.05rem; margin: 0; }
		</style>
		<form id="product-packaging" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="products"></datalist>
			<datalist id="manufacturers"></datalist>
			<div class="fsb">
				<label>Empresa<sup>*</sup><input id="company_id" type="text" list="companies" required></label>
				<label>ID<input id="id" type="text" disabled></label>
				<label>Produto<sup>*</sup><input id="product_id" type="text" list="products" required></label>
			</div>
			<div class="fsb">
				<label>Código<sup>*</sup><input id="code" type="text" placeholder="1X60" required></label>
				<label>Nível<sup>*</sup>
					<select id="level" required>
						<option value="S">Secundária</option>
						<option value="T">Terciária</option>
						<option value="P">Primária</option>
					</select>
				</label>
				<label>Fator<sup>*</sup><input id="factor" type="text" placeholder="60" required></label>
				<label>Cap. terciária<input id="tertiary_capacity" type="text" placeholder="100"></label>
			</div>
			<div class="fsb">
				<label title="Fabricante ao qual este GTIN se refere (opcional; se vazio, usa o fabricante do produto ao salvar)">Fabricante (GTIN)<input id="manufacturer_id" type="text" list="manufacturers" placeholder="Opcional — padrão = produto"></label>
				<label>GTIN<input id="gtin" type="text" placeholder="EAN da embalagem"></label>
				<label title="Conteúdo ou identificador impresso no QR da etiqueta de embalagem">QR Code (etiqueta)
					<input id="qr_code" type="text" placeholder="Opcional — ver texto abaixo" autocomplete="off">
				</label>
			</div>
			<p class="pkg-hint"><strong>GTIN e fabricante:</strong> o cadastro de <strong>produto</strong> ainda pode ter GTIN e fabricante (modelo legado). Eles continuam válidos para tributação e integrações. Aqui você amarra o <strong>EAN desta embalagem (P/S/T)</strong> ao fabricante correto quando for diferente ou quando quiser rastreabilidade explícita. Se deixar fabricante vazio, ao salvar usamos o fabricante do produto. Duplicar GTIN no produto e na embalagem é esperado na migração; operações com hierarquia de embalagens preferem o GTIN deste cadastro quando a empresa ativa essas opções.</p>
			<p class="pkg-hint"><strong>QR Code:</strong> campo opcional para guardar o <em>payload</em> que será codificado no QR da etiqueta de embalagem (ex.: código interno, GTIN+lote, JSON compacto — conforme layout acordado). Pode ser preenchido manualmente ou copiado do gerador/impressor de etiquetas; o SIAL armazena o valor para uso em relatórios, coletor ou futura geração automática de ZPL/PDF.</p>
			<div class="pkg-check-row">
				<label title="Embalagem padrão do produto para fatores/GTIN"><input id="is_default" type="checkbox"> Padrão</label>
				<label title="Cadastro inativo (não aparece em seleções)"><input id="is_disabled" type="checkbox"> Inativa</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
	form: {
		selector: '#product-packaging',
		init(formset) {
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			formset.loadList('#manufacturers', 'manufacturers', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#product_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'] })] },
		{ properties: { selector: '#manufacturer_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('manufacturers', { labels: ['nick'] })] },
		{ properties: { selector: '#code' }, types: [types.name()] },
		{ properties: { selector: '#level' }, types: [] },
		{ properties: { selector: '#factor' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#tertiary_capacity' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#gtin' }, types: [types.gtin(), types.caps()] },
		{ properties: { selector: '#qr_code' }, types: [types.name()] },
		{ properties: { selector: '#is_default' }, types: [types.checkbox()] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
	]
};
